import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import {
  changeIsFirst,
  changeIsSemibasement,
  changeMaxFloor,
  changeMinFloor,
  changeNotLast,
} from '../../../../../../state/advanced/floor';

import { Floor as FloorComponent } from './floor';

export function mapStateToProps(state: IAppState) {
  return {
    maxFloor: state.filters.jsonQuery.floor && state.filters.jsonQuery.floor.value.lte,
    minFloor: state.filters.jsonQuery.floor && state.filters.jsonQuery.floor.value.gte,
    isNotFirst: state.filters.jsonQuery.is_first_floor && state.filters.jsonQuery.is_first_floor.value,
    isNotLast: state.filters.jsonQuery.not_last_floor && state.filters.jsonQuery.not_last_floor.value,
    isSemibasement: !!(state.filters.jsonQuery.is_semibasement && state.filters.jsonQuery.is_semibasement.value),
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onMinFloorChange: (value: number | undefined) => {
      dispatch(changeMinFloor(value));
    },
    onMaxFloorChange: (value: number | undefined) => {
      dispatch(changeMaxFloor(value));
    },
    onIsNotFirstChange: (value: boolean | undefined) => {
      dispatch(changeIsFirst(value));
    },
    onIsNotLastChange: (value: boolean | undefined) => {
      dispatch(changeNotLast(value));
    },
    onIsSemibasementChange: (value: boolean | undefined) => {
      dispatch(changeIsSemibasement(value));
    },
  };
}

export const Floor = connect(mapStateToProps, mapDispatchToProps)(FloorComponent);
